<template>
  <header class="main-header">
    <div class="header-left">
      <button class="sidebar-toggle-btn" @click="$emit('toggle-sidebar')" title="Show/Hide Sidebar">
        <i :class="sidebarOpen ? 'fas fa-angle-double-left' : 'fas fa-angle-double-right'"></i>
      </button>
      <slot name="title">
        <span class="header-title">MIC</span>
      </slot>
    </div>
    <div class="header-actions">
      <div class="profile-dropdown" @click="toggleDropdown" :class="{ open: dropdownOpen }">
        <img class="profile-avatar" src="@/assets/img/mic.jpg" alt="Profile" />
        <i class="fas fa-caret-down"></i>
        <div v-if="dropdownOpen" class="dropdown-menu">
          <!-- <a href="#" @click.prevent="$emit('account-setting')"><i class="fas fa-user-cog"></i> Profile</a> -->
          <a href="#" @click="logout()"><i class="fas fa-sign-out-alt"></i> Logout</a>
        </div>
      </div>
      <slot name="actions"></slot>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  props: {
    sidebarOpen: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      dropdownOpen: false
    }
  },
  methods: {
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    logout() {
        window.localStorage.removeItem('token');
        window.localStorage.removeItem('user');
        window.localStorage.removeItem('church');
        this.$router.replace('/login');
    },
  }
}
</script>

<style scoped lang="scss">
.sidebar-toggle-btn {
  background: none;
  border: none;
  color: #fff;
  font-size: 1.3rem;
  margin-right: 18px;
  margin-left: 50px;
  cursor: pointer;
  outline: none;
  transition: color 0.2s;
}
.sidebar-toggle-btn:hover {
  color: #FFD700;
}
.main-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #001c32;
  padding: 0 32px;
  height: 64px;
  border-radius: 0 0 12px 0px;
  box-shadow: 0 2px 8px rgba(44, 62, 80, 0.08);
  position: sticky;
  top: 0;
  z-index: 100;
  margin-bottom: 0;
}
.header-left {
  display: flex;
  align-items: center;
}
.menu-btn {
  background: none;
  border: none;
  color: #fff;
  font-size: 1.5rem;
  margin-right: 18px;
  cursor: pointer;
  outline: none;
  transition: color 0.2s;
}
.menu-btn:hover {
  color: #FFD700;
}
.header-title {
  color: #fff;
  font-size: 1.3rem;
  font-weight: 700;
  letter-spacing: 1px;
  text-shadow: 0 2px 8px rgba(44, 62, 80, 0.10);
}
.header-actions {
  display: flex;
  align-items: center;
}
.profile-dropdown {
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-right: 10px;
}
.profile-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  object-fit: contain;
  margin-right: 8px;
  border: 2px solid #fff;
  box-shadow: 0 2px 8px rgba(44, 62, 80, 0.10);
}
.profile-avatar img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: contain;
}
.profile-dropdown i.fa-caret-down {
  color: #fff;
  font-size: 1.1rem;
}
.profile-dropdown.open .dropdown-menu {
  display: block;
}
.dropdown-menu {
  display: none;
  position: absolute;
  top: 48px;
  right: 0;
  left: auto;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(44, 62, 80, 0.15);
  min-width: 160px;
  z-index: 200;
  padding: 8px 0;
}
.dropdown-menu a {
  display: flex;
  align-items: center;
  padding: 10px 18px;
  color: #333;
  text-decoration: none;
  font-size: 1rem;
  transition: background 0.2s, color 0.2s;
}
.dropdown-menu a i {
  margin-right: 10px;
  font-size: 1.1rem;
}
.dropdown-menu a:hover {
  background: #4F8A8B;
  color: #fff;
}
</style>
